module.exports = __webpack_public_path__ + "static/media/product_list_2.725d62d4.png";